export default function Header() {
  return (
    <header className="header">
      <div className="logo-img-box">
        <img className="logo" src="/logo512.png" alt="react logo" />
      </div>
      <h1 className="header-title">the react quiz</h1>
    </header>
  );
}
